import { deepEqual } from "fast-equals";

/**
 * This function checks if a value is present in an array.
 * It handles both primitive values and objects by comparing their stringified versions.
 * @param array
 * @param value
 * @returns
 */
export function isInArray<T>(array: T[], value: T): boolean {
	if (typeof value === "object" && value !== null) {
		return array.some((item) => deepEqual(item, value));
	} else {
		return array.includes(value);
	}
}
